cobalt-tag {
  display: inline-flex;
}
